function calcResidualValue(purchaseMethod, lifetimeMiles) {
  var lnResidual;

  if (purchaseMethod === 'lease') {
    // 45% left after 36k miles / 12k miles per year over 3 years
    lnResidual = Math.log(0.45);
  } else {
    // 60% left after 36k miles / 12k miles per year over 3 years
    lnResidual = Math.log(0.6);
  }

  var depreciationCoefficient = lnResidual / 36000;
  return Math.exp(depreciationCoefficient * lifetimeMiles);
}

module.exports = calcResidualValue;
